export default __webpack_public_path__ + "static/media/el1.1ac01052.jpeg";